/**
 * PDP Luxury - Product Detail Page JavaScript
 * Handles interactions, animations, and sticky cart
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', initPDPLuxury);

  function initPDPLuxury() {
    initAccordion();
    initGallery();
    initMobileCarouselAutoplay();
    initVariantPriceAnimation();
    initQuantitySelector();
    initPromotionalOffersClick();
    initCouponsOffersClick();
    initCarouselDots();
  }

  /**
   * Accordion functionality for description/details
   */
  function initAccordion() {
    const accordionItems = document.querySelectorAll('.pdp-accordion__item');
    
    accordionItems.forEach(item => {
      const header = item.querySelector('.pdp-accordion__header');
      
      if (header) {
        header.addEventListener('click', () => {
          const isActive = item.classList.contains('active');
          
          // Close all others
          accordionItems.forEach(i => i.classList.remove('active'));
          
          // Toggle current
          if (!isActive) {
            item.classList.add('active');
          }
        });
      }
    });
    
    // Open first accordion by default
    if (accordionItems.length > 0) {
      accordionItems[0].classList.add('active');
    }
  }

  /**
   * Gallery thumbnail click handling
   * Supports both vertical and horizontal gallery layouts
   * Desktop: Thumbnail clicks update desktop slides
   * Mobile: Carousel handled by slider-component
   */
  function initGallery() {
    // Vertical gallery handling (desktop only)
    const verticalThumbnails = document.querySelectorAll('.pdp-gallery-vertical__thumbnail');
    const desktopSlidesContainer = document.querySelector('.pdp-gallery-vertical__desktop-slides');
    
    if (verticalThumbnails.length > 0 && desktopSlidesContainer) {
      const desktopSlides = desktopSlidesContainer.querySelectorAll('.pdp-gallery-vertical__slide');
      
      if (desktopSlides.length > 0) {
      verticalThumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const mediaId = thumb.getAttribute('data-media-id');
          
          // Update active thumbnail
          verticalThumbnails.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-current', 'false');
          });
          thumb.classList.add('active');
          thumb.setAttribute('aria-current', 'true');
          
            // Update active slide (desktop only)
            desktopSlides.forEach(slide => {
            slide.classList.remove('active');
          });
          
            const targetSlide = desktopSlidesContainer.querySelector(`.pdp-gallery-vertical__slide[data-media-id="${mediaId}"]`);
          if (targetSlide) {
            targetSlide.classList.add('active');
          }
        });
      });
      
      // Set first thumbnail as active if none is active
      const activeThumb = document.querySelector('.pdp-gallery-vertical__thumbnail.active');
      if (!activeThumb && verticalThumbnails[0]) {
        verticalThumbnails[0].classList.add('active');
        verticalThumbnails[0].setAttribute('aria-current', 'true');
        }
      }
    }
    
    // Legacy horizontal gallery handling
    const thumbnails = document.querySelectorAll('.pdp-gallery__thumbnail');
    const mainImage = document.querySelector('.pdp-gallery__main-image');
    
    if (mainImage && thumbnails.length > 0) {
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => {
          // Update active state
          thumbnails.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          
          // Update main image with fade
          const newSrc = thumb.querySelector('img')?.src;
          if (newSrc) {
            mainImage.style.opacity = '0';
            setTimeout(() => {
              mainImage.src = newSrc;
              mainImage.style.opacity = '1';
            }, 150);
          }
        });
      });
      
      // Set first thumbnail as active
      if (thumbnails[0]) {
        thumbnails[0].classList.add('active');
      }
    }
  }

  /**
   * Animate price on variant change
   */
  function initVariantPriceAnimation() {
    const priceContainer = document.querySelector('.pdp-info__price');
    
    if (!priceContainer) return;
    
    // Listen for variant changes
    document.addEventListener('variant:changed', (e) => {
      if (e.detail && e.detail.variant) {
        // Add animation class
        priceContainer.classList.add('pdp-animate-in');
        
        // Remove after animation
        setTimeout(() => {
          priceContainer.classList.remove('pdp-animate-in');
        }, 400);
      }
    });
  }

  /**
   * Quantity selector +/- buttons
   */
  function initQuantitySelector() {
    const quantityContainers = document.querySelectorAll('.pdp-quantity__controls');
    
    quantityContainers.forEach(container => {
      const input = container.querySelector('.pdp-quantity__input');
      const decreaseBtn = container.querySelector('.pdp-quantity__btn--decrease');
      const increaseBtn = container.querySelector('.pdp-quantity__btn--increase');
      
      if (!input) return;
      
      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > 1) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      
      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          const max = parseInt(input.max) || 99;
          if (currentValue < max) {
            input.value = currentValue + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }

  /**
   * Smooth scroll to reviews
   */
  window.scrollToReviews = function() {
    const reviewsSection = document.querySelector('.pdp-reviews');
    if (reviewsSection) {
      reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  /**
   * Image zoom on click (lightbox trigger)
   */
  window.openImageLightbox = function(imageSrc) {
    // This can integrate with existing lightbox or create simple modal
    const existingLightbox = document.querySelector('[data-pswp-uid]');
    if (existingLightbox) {
      // Trigger existing lightbox
      existingLightbox.click();
    }
  };

  /**
   * Mobile carousel auto-scroll functionality
   * Automatically advances slides with pause on user interaction
   */
  function initMobileCarouselAutoplay() {
    // Only run on mobile viewport
    if (window.innerWidth >= 750) return;

    const mobileCarousel = document.querySelector('.pdp-gallery-vertical__mobile-carousel');
    if (!mobileCarousel) return;

    const slider = mobileCarousel.querySelector('[id^="Slider-"]');
    const sliderComponent = mobileCarousel.closest('slider-component') || mobileCarousel;
    const nextButton = mobileCarousel.querySelector('button[name="next"]');
    const prevButton = mobileCarousel.querySelector('button[name="previous"]');
    const slides = mobileCarousel.querySelectorAll('[id^="Slide-"]');

    if (!slider || !nextButton || slides.length <= 1) return;

    // Check for reduced motion preference
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;

    let autoplayInterval = null;
    let isPaused = false;
    const autoplayDelay = 4000; // 4 seconds between slides

    // Calculate slide width for scrolling
    function getSlideWidth() {
      if (slides.length === 0) return 0;
      // Use the actual slide width
      const firstSlide = slides[0];
      return firstSlide.offsetWidth || slider.clientWidth;
    }

    // Get current slide index
    function getCurrentSlideIndex() {
      const slideWidth = getSlideWidth();
      if (slideWidth === 0) return 0;
      return Math.round(slider.scrollLeft / slideWidth);
    }

    // Advance to next slide
    function advanceSlide() {
      if (isPaused || slides.length <= 1) return;

      const currentIndex = getCurrentSlideIndex();
      const nextIndex = (currentIndex + 1) % slides.length;
      const slideWidth = getSlideWidth();
      
      // Scroll to next slide position
      const nextPosition = nextIndex * slideWidth;
      
      slider.scrollTo({
        left: nextPosition,
        behavior: 'smooth'
      });
    }

    // Start autoplay
    function startAutoplay() {
      if (autoplayInterval || isPaused) return;
      stopAutoplay();
      autoplayInterval = setInterval(advanceSlide, autoplayDelay);
    }

    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Pause autoplay temporarily
    function pauseAutoplay() {
      isPaused = true;
      stopAutoplay();
    }

    // Resume autoplay
    function resumeAutoplay() {
      isPaused = false;
      // Restart after a short delay to allow user interaction to complete
      setTimeout(() => {
        if (!isPaused) {
          startAutoplay();
        }
      }, 1000);
    }

    // Pause on touch/interaction
    let touchEndTimeout;
    slider.addEventListener('touchstart', () => {
      pauseAutoplay();
      clearTimeout(touchEndTimeout);
    }, { passive: true });
    
    slider.addEventListener('touchmove', pauseAutoplay, { passive: true });
    
    slider.addEventListener('touchend', () => {
      clearTimeout(touchEndTimeout);
      // Resume after a delay to allow user to see the result of their swipe
      touchEndTimeout = setTimeout(resumeAutoplay, 2000);
    }, { passive: true });

    // Pause on mouse interaction (for devices with mouse)
    slider.addEventListener('mousedown', pauseAutoplay);
    slider.addEventListener('mouseup', resumeAutoplay);
    slider.addEventListener('mouseenter', pauseAutoplay);
    slider.addEventListener('mouseleave', resumeAutoplay);

    // Pause on button clicks
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        pauseAutoplay();
        resumeAutoplay();
      });
    }
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        pauseAutoplay();
        resumeAutoplay();
      });
    }

    // Pause on manual scroll
    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      pauseAutoplay();
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(resumeAutoplay, 2000);
    }, { passive: true });

    // Pause when carousel is not visible (page scrolled away)
    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          resumeAutoplay();
        } else {
          pauseAutoplay();
        }
      });
    }, { threshold: 0.5 });

    visibilityObserver.observe(mobileCarousel);

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth >= 750) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      }, 250);
    });

    // Start autoplay after a short delay to allow page to load
    setTimeout(() => {
      if (window.innerWidth < 750) {
        startAutoplay();
      }
    }, 1000);
  }

  /**
   * Promotional offers click handler
   * Adds product to cart and redirects to checkout with discount code
   */
  function initPromotionalOffersClick() {
    const offerItems = document.querySelectorAll('.pdp-promotional-offers__item--clickable[data-coupon-code]');
    
    if (offerItems.length === 0) return;

    offerItems.forEach(item => {
      item.addEventListener('click', async (e) => {
        e.preventDefault();
        
        // Check if item is disabled
        if (item.disabled || item.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const couponCode = item.getAttribute('data-coupon-code');
        if (!couponCode) {
          console.warn('No coupon code found for promotional offer');
          return;
        }

        // Get product variant ID - try multiple methods
        let variantId = null;
        
        // Method 1: Look for hidden input in product form
        const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
                           document.querySelector('product-form input[name="id"]') ||
                           document.querySelector('form.product-form input[name="id"]');
        
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        } else {
          // Method 2: Look for variant input within product-info
          const productInfo = document.querySelector('product-info');
          if (productInfo) {
            const infoVariantInput = productInfo.querySelector('input[name="id"]');
            if (infoVariantInput && infoVariantInput.value) {
              variantId = infoVariantInput.value;
            }
          }
        }

        if (!variantId) {
          // Show error if no variant found
          showPromotionalOfferError(item, 'Please select a product variant');
          return;
        }

        await handlePromotionalOfferClick(variantId, couponCode, item);
      });
    });
  }

  /**
   * Handle promotional offer click - add to cart and redirect
   */
  async function handlePromotionalOfferClick(variantId, couponCode, item) {
    // Show loading state
    item.classList.add('pdp-promotional-offers__item--loading');
    item.disabled = true;

    try {
      // Get quantity (default to 1)
      const quantityInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      // Add product to cart
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      const cartAddUrl = (window.routes && window.routes.cart_add_url) 
        ? window.routes.cart_add_url 
        : '/cart/add.js';

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const data = await response.json().catch(() => null);

      // Check for errors
      if (!response.ok || (data && data.status)) {
        const errorMessage = (data && (data.description || data.message)) || 'Failed to add product to cart';
        throw new Error(errorMessage);
      }

      // Success - redirect to checkout with discount code
      const checkoutUrl = `/checkout?discount=${encodeURIComponent(couponCode)}`;
      window.location.href = checkoutUrl;

    } catch (error) {
      console.error('Error adding product to cart:', error);
      showPromotionalOfferError(item, error.message || 'Unable to add product to cart. Please try again.');
      
      // Remove loading state
      item.classList.remove('pdp-promotional-offers__item--loading');
      item.disabled = false;
    }
  }

  /**
   * Show error message for promotional offer
   */
  function showPromotionalOfferError(item, message) {
    // Create or update error message element
    let errorElement = item.parentElement.querySelector('.pdp-promotional-offers__error');
    
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'pdp-promotional-offers__error';
      item.parentElement.appendChild(errorElement);
    }

    errorElement.textContent = message;
    errorElement.setAttribute('role', 'alert');
    errorElement.style.display = 'block';

    // Hide error after 5 seconds
    setTimeout(() => {
      if (errorElement) {
        errorElement.style.display = 'none';
      }
    }, 5000);
  }

  /**
   * Coupons & Offers click handler
   * Handles both coupon code application and custom link navigation
   */
  function initCouponsOffersClick() {
    const offerButtons = document.querySelectorAll('.pdp-coupons-offers__button[data-action-type]');
    
    if (offerButtons.length === 0) return;

    offerButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        
        // Check if button is disabled
        if (button.disabled || button.classList.contains('pdp-coupons-offers__button--disabled')) {
          return;
        }

        const actionType = button.getAttribute('data-action-type');
        
        if (actionType === 'coupon') {
          // Handle coupon code
          const couponCode = button.getAttribute('data-coupon-code');
          if (!couponCode) {
            showCouponsOffersError(button, 'No coupon code found for this offer');
            return;
          }

          // Get product variant ID
          let variantId = null;
          const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
                             document.querySelector('product-form input[name="id"]') ||
                             document.querySelector('form.product-form input[name="id"]');
          
          if (variantInput && variantInput.value) {
            variantId = variantInput.value;
          } else {
            const productInfo = document.querySelector('product-info');
            if (productInfo) {
              const infoVariantInput = productInfo.querySelector('input[name="id"]');
              if (infoVariantInput && infoVariantInput.value) {
                variantId = infoVariantInput.value;
              }
            }
          }

          if (!variantId) {
            showCouponsOffersError(button, 'Please select a product variant');
            return;
          }

          await handleCouponOfferClick(variantId, couponCode, button);
        } else if (actionType === 'link') {
          // Handle custom link - navigation is handled by the anchor tag
          // This is just for tracking/analytics if needed
          const link = button.getAttribute('href');
          if (link) {
            // Link navigation will happen naturally via the anchor tag
            // Add any analytics tracking here if needed
          }
        }
      });
    });
  }

  /**
   * Handle coupon offer click - add to cart and redirect to checkout
   */
  async function handleCouponOfferClick(variantId, couponCode, button) {
    // Add loading state
    button.classList.add('pdp-coupons-offers__button--loading');
    button.disabled = true;
    const originalText = button.textContent;

    try {
      // Get quantity
      const quantityInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      // Add to cart
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      const cartAddUrl = (window.routes && window.routes.cart_add_url) 
        ? window.routes.cart_add_url 
        : '/cart/add.js';

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const data = await response.json().catch(() => null);

      if (!response.ok || (data && data.status)) {
        const errorMessage = (data && (data.description || data.message)) 
          || 'Failed to add product to cart';
        throw new Error(errorMessage);
      }

      // Redirect to checkout with discount code
      const checkoutUrl = `/checkout?discount=${encodeURIComponent(couponCode)}`;
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error('Error adding product to cart:', error);
      showCouponsOffersError(button, error.message || 'Unable to add product to cart. Please try again.');
      
      // Remove loading state
      button.classList.remove('pdp-coupons-offers__button--loading');
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  /**
   * Show error message for coupons & offers
   */
  function showCouponsOffersError(button, message) {
    const card = button.closest('.pdp-coupons-offers__card');
    if (!card) return;

    let errorElement = card.querySelector('.pdp-coupons-offers__error');
    
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'pdp-coupons-offers__error';
      card.appendChild(errorElement);
    }

    errorElement.textContent = message;
    errorElement.setAttribute('role', 'alert');
    errorElement.style.display = 'block';

    // Hide error after 5 seconds
    setTimeout(() => {
      if (errorElement) {
        errorElement.style.display = 'none';
      }
    }, 5000);
  }

  /**
   * Carousel dots navigation
   * Handles dot clicks to navigate slides and updates active state
   */
  function initCarouselDots() {
    const carouselDots = document.querySelectorAll('.pdp-carousel-dots__dot');
    
    if (carouselDots.length === 0) return;
    
    carouselDots.forEach(dot => {
      dot.addEventListener('click', () => {
        const slideIndex = parseInt(dot.getAttribute('data-slide-index'), 10);
        const carouselWrapper = dot.closest('.pdp-carousel-dots');
        const sliderId = dot.getAttribute('aria-controls');
        
        // Find the slider component
        let slider = null;
        if (sliderId) {
          slider = document.getElementById(sliderId);
        } else {
          // Fallback: find nearest slider-component
          const sliderComponent = carouselWrapper?.closest('slider-component') || 
                                  carouselWrapper?.closest('[id^="Slider-"]')?.parentElement;
          if (sliderComponent) {
            slider = sliderComponent.querySelector('[id^="Slider-"]') || 
                    sliderComponent.querySelector('.slider');
          }
        }
        
        if (slider) {
          const slides = slider.querySelectorAll('[id^="Slide-"]');
          if (slides[slideIndex]) {
            // Scroll to the target slide
            const slideWidth = slides[0].offsetWidth || slider.clientWidth;
            const targetPosition = slideIndex * slideWidth;
            
            slider.scrollTo({
              left: targetPosition,
              behavior: 'smooth'
            });
            
            // Update active dot
            carouselDots.forEach(d => d.classList.remove('pdp-carousel-dots__dot--active'));
            dot.classList.add('pdp-carousel-dots__dot--active');
            
            // Update counter
            const counter = carouselWrapper?.querySelector('.pdp-carousel-dots__current');
            if (counter) {
              counter.textContent = slideIndex + 1;
            }
          }
        }
      });
    });
    
    // Update dots on slide change (for swipe/scroll)
    const sliders = document.querySelectorAll('[id^="Slider-"]');
    sliders.forEach(slider => {
      let scrollTimeout;
      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const slides = slider.querySelectorAll('[id^="Slide-"]');
          if (slides.length === 0) return;
          
          const slideWidth = slides[0].offsetWidth || slider.clientWidth;
          const currentIndex = Math.round(slider.scrollLeft / slideWidth);
          
          // Find corresponding carousel dots
          const carouselDotsWrapper = slider.closest('slider-component')?.querySelector('.pdp-carousel-dots') ||
                                     slider.closest('.product__media-wrapper')?.querySelector('.pdp-carousel-dots');
          
          if (carouselDotsWrapper) {
            const dots = carouselDotsWrapper.querySelectorAll('.pdp-carousel-dots__dot');
            const counter = carouselDotsWrapper.querySelector('.pdp-carousel-dots__current');
            
            dots.forEach((dot, index) => {
              if (index === currentIndex) {
                dot.classList.add('pdp-carousel-dots__dot--active');
              } else {
                dot.classList.remove('pdp-carousel-dots__dot--active');
              }
            });
            
            if (counter) {
              counter.textContent = currentIndex + 1;
            }
          }
        }, 100);
      }, { passive: true });
    });
  }

})();

